import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';

export default function Reveal({ children, className = '', delay = 0 }) {
  const [ref, visible] = useScrollReveal();
  const style = delay ? { transitionDelay: `${delay}ms` } : undefined;

  return (
    <div ref={ref} className={`reveal ${visible ? 'is-visible' : ''} ${className}`.trim()} style={style}>
      {children}
    </div>
  );
}
